var map = {
	"./symbol_0.png": "4383",
	"./symbol_1.png": "0af7",
	"./symbol_2.png": "4c8e",
	"./symbol_3.png": "9eb5",
	"./symbol_4.png": "1e32",
	"./symbol_5.png": "224a",
	"./symbol_6.png": "9408",
	"./symbol_7.png": "5a73",
	"./symbol_8.png": "0e45"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "347c";